export default __webpack_public_path__ + "static/media/checkmark.ff1239f8.webp";